import {
  Checkbox,
  CheckboxProps,
} from '@delmonicos/shared-design-system-react/src/components/checkbox/checkbox';
import { useTranslation } from 'react-i18next';

interface CustomerIsExemptFromBillingFilterControllerProps
  extends Pick<CheckboxProps, 'onChange' | 'checked'> {}

export const CustomerIsExemptFromBillingFilterController = ({
  onChange,
  checked,
}: CustomerIsExemptFromBillingFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Checkbox
      id="isExemptFromBilling"
      label={t('delmonicos-shared-sdk.outputs-customer.is-exempt-from-billing')}
      checked={checked}
      onChange={onChange}
    />
  );
};
